import { render, staticRenderFns } from "./AppSvgIcon.vue?vue&type=template&id=46ac5ae9&scoped=true"
import script from "./AppSvgIcon.vue?vue&type=script&lang=js"
export * from "./AppSvgIcon.vue?vue&type=script&lang=js"
import style0 from "./AppSvgIcon.vue?vue&type=style&index=0&id=46ac5ae9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ac5ae9",
  null
  
)

export default component.exports